module.exports = __webpack_public_path__ + "img/ibs logo.f3c3f846.png";